import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';
import { DEFAULT_PAGE_SIZE } from '../config/config';
import AdministratorService from '../services/AdministratorService';
import AuthoritiesService from '../services/AuthoritiesService';
import { PaginationParams } from '../types';
import { AdministratorModel } from '../types/Administrator';
import { transformToValueLabel } from '../utils/functions';


class AdministratorStore {
    loading: boolean = false;
    administratorList: AdministratorModel[] = [];
    administrator: AdministratorModel | undefined;
    administratorSelect: any = [];
    childAdministrator: any = [];
    childEligibleParent: any = [];
    childCustomer: any = [];
    addChildAdministrator: any = [];
    listGroup: any = []
    sort?: string = '';
    totalPages: number = 0;
    loadingChild: boolean = false;
    page: number = 0;
    totalElements: number = 0;
    size: number = DEFAULT_PAGE_SIZE;
    defaultparams = {
        size: DEFAULT_PAGE_SIZE,
        page: 0,
        sort: 'created,desc',
        search: '',
    }

    constructor() {
        makeAutoObservable(this);
    }

    reset() {
        this.administrator = undefined;
        this.administratorList = [];
        this.listGroup = [];
    }

    async getList(params: PaginationParams) {
        this.loading = true;
        const response = await AdministratorService.getList(params);

        if (!response.error) {
            this.administratorList = response.data.content;
            this.totalPages = response.data.totalPages;
            this.administratorSelect = transformToValueLabel(response.data.content, 'uuid', 'name');
            this.page = response.data.number;
            this.totalElements = response.data.totalElements;
            this.size = response.data.size;
            this.sort = params.sort;
        }
        this.loading = false;

        return response;
    }

    async getAdministratorByUuid(uuid: string) {
        this.loading = true;
        const response = await AdministratorService.getAdministratorByUuid(uuid);

        runInAction(() => {
            if (response.error) {
                message.error('Erro ao buscar Administrador');
                return;
            }

            this.listGroup = transformToValueLabel(response.data.user.authorityGroups, 'uuid', 'name');
            this.administrator = response.data;
            this.loading = false;
        });

        return response.data;
    }

    async addIndividualAuthorities(uuid: string | undefined, individualPermission: any) {
        individualPermission.map(async (item: any) => {
            await AuthoritiesService.createIndividualAuthoritie(item.uuid, uuid);
        })
    }

    async deleteIndividualAuthorities(uuid: string | undefined, individualPermission: any) {
        individualPermission.map(async (item: any) => {
            await AuthoritiesService.deleteIndividualAuthoritie(item.uuid, uuid);
        })
    }

    async createAdministrator(data: any, listGroups: any) {
        this.loading = true;
        const response = await AdministratorService.createAdministrator(data);

        if (response.error) {
            message.error(response.error);
        } else {
            message.success('Administrador cadastrado com sucesso!');

            if (listGroups?.length > 0) {
                listGroups.map(async (item: any) => {
                    await AuthoritiesService.createAuthoritiesGroup(item.uuid, response.data.user.uuid);
                })
            }
        }

        this.loading = false;
        return response;
    }

    async editAdministrator(data: any, uuid: string | undefined, groups: any) {
        this.loading = true;
        const response = await AdministratorService.editAdministrator(data, uuid);

        // guarda uuids dos authorityGroups já salvos no admin
        const setLista1 = new Set(this.listGroup?.map((item: any) => item.value));
        // guarda uuids dos authorityGroups selecionados ao editar
        const setLista2 = new Set(groups?.map((item: any) => item.uuid));
        // devolve o item que não está em setLista1
        const newGroup = groups?.filter((item: any) => !setLista1?.has(item.uuid));
        // devolve o item que não está em setLista2 (que não foi selecionado)
        const removeGroup = this.listGroup?.filter((item: any) => !setLista2?.has(item.value));

        if (response.error) {
            message.error('Erro ao editar Administrador');
            this.administrator = data;
        } else {
            message.success('Administrador editado com sucesso!');

            // Grupo de Usuario
            if (newGroup?.length > 0) {
                newGroup?.map(async (item: any) => {
                    await AuthoritiesService.createAuthoritiesGroup(item.uuid, response.data.user.uuid)
                })
            }

            if (removeGroup?.length > 0) {
                removeGroup.map(async (item: any) => {
                    await AuthoritiesService.deleteAuthoritiesGroup(item.value, response.data.user.uuid)
                })
            }
        }

        this.loading = false;
        return [];
    }

    async deleteAdministratorAll(uuid: string) {
        this.loading = true;
        const response = await AdministratorService.deleteAdministrator(uuid);
        this.administrator = response.data;
        this.loading = false;
        return response;
    }


    async deleteAdministrator(uuid: string) {
        this.loading = true;
        const response = await AdministratorService.deleteAdministrator(uuid);
        if (response.error) {
            message.error(`Erro ao deletar Administrador`);
        } else {
            message.success('Administrador deletado com sucesso!');
        }
        this.administrator = response.data;
        this.loading = false;
        return response;
    }



    async getEligibleParent(hierarchy: string) {
        const response = await AdministratorService.getEligibleParent(hierarchy);

        if (!response.error) {
            this.childEligibleParent = transformToValueLabel(response.data.content, 'uuid', 'name');

            if (response.data.content.length === 0) {
                message.error('Nenhum administrador foi encontrado para a busca realizada.');
            }
        }
    }

    // Administrator
    async getChildAdministratorByTerm(term: string) {
        const response = await AdministratorService.getChildAdminstratorByTerm(term);

        if (!response.error) {
            const selectAdministratorList = transformToValueLabel(response.data.content, 'uuid', 'name');

            if (response.data.content.length === 0) {
                message.error('Nenhum administrador foi encontrado para a busca realizada.');
            }

            return selectAdministratorList;
        }
    }

    async getChildAdministrator(uuid: string | undefined, params: PaginationParams) {
        this.loadingChild = true;
        const response = await AdministratorService.getChildAdminstrator(uuid, params);

        if (!response.error) {
            this.childAdministrator = response.data.content;
            this.page = response.data.number;
            this.totalElements = response.data.totalElements;
            this.size = response.data.size;
        }

        this.loadingChild = false;
    }

    async addChildAdministratorAction(item: any) {
        const filterAdministrador = this.childAdministrator.some((prop: any) => prop.uuid === item.value);

        if (!filterAdministrador) {
            const administradorUUid = this.administrator?.uuid;
            const response = await AdministratorService.addChildAdminstrator(administradorUUid, [item.value]);

            if (!response.error) {
                message.success('Administrador adicionado com sucesso');
                this.getChildAdministrator(administradorUUid, this.defaultparams);
            } else {
                message.error('Erro ao adicionar Administrador');
            }
        } else {
            message.error('Administrador já cadastrado');
        }
    }


    async removeChildAdminstrator(item: any) {
        const administradorUUid = this.administrator?.uuid;
        const payload = [item.uuid];

        const response = await AdministratorService.removeChildAdminstrator(administradorUUid, payload);

        if (!response.error) {
            message.success('Administrador removido com sucesso');
            this.getChildAdministrator(administradorUUid, this.defaultparams);
        } else {
            message.error('Erro ao remover Administrador');
        }
    }



    // Customer
    async getChildCustomerByTerm(term: string) {
        const response = await AdministratorService.getChildCustomerByTerm(term);

        if (!response.error) {
            const selectCustomerList = transformToValueLabel(response.data.content, 'uuid', 'firstName');

            if (response.data.content.length === 0) {
                message.error('Nenhum cliente foi encontrado para a busca realizada.');
            }

            return selectCustomerList;
        }
    }


    async getChildCustomer(uuid: string | undefined, params: PaginationParams) {
        this.loadingChild = true;
        const response = await AdministratorService.getChildCustomer(uuid, params);

        if (!response.error) {
            this.childCustomer = response.data.content;
            this.page = response.data.number;
            this.totalElements = response.data.totalElements;
            this.size = response.data.size;
        }

        this.loadingChild = false;
    }

    async addChildCustomerAction(item: any) {
        const filterAdministrador = this.childCustomer.some((prop: any) => prop.uuid === item.value);

        if (!filterAdministrador) {
            const administradorUUid = this.administrator?.uuid;
            const response = await AdministratorService.addChildCustomer(administradorUUid, [item.value]);

            if (!response.error) {
                message.success('Cliente adicionado com sucesso');
                this.getChildCustomer(administradorUUid, this.defaultparams);
            } else {
                message.error('Erro ao adicionar Cliente');
            }
        } else {
            message.error('Cliente já cadastrado');
        }
    }

    async removeChildCustomer(item: any) {
        const administradorUUid = this.administrator?.uuid;
        const payload = [item.uuid];

        const response = await AdministratorService.removeChildCustomer(administradorUUid, payload);

        if (!response.error) {
            message.success('Cliente removido com sucesso');
            this.getChildCustomer(administradorUUid, this.defaultparams);
        } else {
            message.error('Erro ao remover Cliente');
        }
    }
}

const administratorStore = new AdministratorStore();
export default administratorStore;